import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../services/authentication/supabaseService';
import { Header } from '../landingpage/sections/Header';
import { useAuth } from '../../../services/authentication/authContext';
import { Navigate } from 'react-router-dom';

export default function ForgotPassword() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
    }
  };

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="relative overflow-hidden min-h-screen bg-landingPageBG text-white">
      <Header />
      <div className="flex justify-center px-5 pt-20">
        <div className="relative z-10 w-full max-w-md h-fit">
          <div className="rounded-2xl border border-white/10 p-8 bg-white/5 backdrop-blur-sm">
            <h1 className="text-2xl font-semibold text-white mb-2">{t('auth.forgotPassword')}</h1>
            <p className="text-sm text-white/70 mb-6">{t('auth.forgotPasswordDescription')}</p>

            {success ? (
              <div className="mb-4 p-4 rounded-xl bg-green-500/10 border border-green-500/30 text-green-300">
                <p className="font-medium mb-2">{t('auth.resetEmailSent')}</p>
                <p className="text-sm">{t('auth.resetEmailSentDescription')}</p>
              </div>
            ) : (
              <>
                {error && (
                  <div className="mb-4 p-3 rounded-xl bg-red-500/10 border border-red-500/30 text-red-300 text-sm">
                    {error}
                  </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <input
                      type="email"
                      placeholder="Email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      required
                      className="w-full px-4 py-3 border border-white/20 rounded-xl bg-white/10 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full px-6 py-3 text-base font-semibold bg-accent text-white hover:bg-accent/90 rounded-2xl transition disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? t('auth.sendingResetLink') : t('auth.sendResetLink')}
                  </button>
                </form>
              </>
            )}

            <p className="mt-6 text-center text-sm text-white/70">
              {t('auth.rememberPassword')}{' '}
              <a href="/login" className="text-white font-medium hover:underline">
                {t('auth.backToLogin')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
